import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import { destinationPickerDTPageType, fareFinderDTPageType, flightIsm2PageType, flightsIsmDTNewPageType, flightsStaticPageType } from '../utils/Constants';

// Dynamic imports for components
const FlightRouteDT = dynamic(() => import('../components/FlightRouteDT'));
const FlightRoutePWA = dynamic(() => import('../components/FlightRoutePWA'));
const FareFinderDT = dynamic(() => import('../components/FareFinderDT'));
const FlightDistanceDT = dynamic(() => import('../components/FlightDistanceDT'));
const CityDT = dynamic(() => import('../components/CityDT'));
const CityCountryDT = dynamic(() => import('../components/CityCountryDT'));
const Offers = dynamic(() => import('../components/offers'));
const FlightDistancePWA = dynamic(() => import('../components/FlightDistancePWA'));
const CityPWA = dynamic(() => import('../components/CityPWA'));

export default function Body(props) {
  const { data } = props || {};
  const { pageType, isDeviceMobile } = data || {};
  return (
    <>
      { pageType === 'offerPage' && <Offers data={data} />}
      { flightsIsmDTNewPageType[pageType] && !isDeviceMobile && <FlightRouteDT data={data} /> }
      { flightsIsmDTNewPageType[pageType] && isDeviceMobile && <FlightRoutePWA data={data} /> }
      { fareFinderDTPageType[pageType] && <FareFinderDT data={data} /> }
      { flightIsm2PageType[pageType] && !isDeviceMobile && <FlightDistanceDT data={data} />}
      { flightIsm2PageType[pageType] && isDeviceMobile && <FlightDistancePWA data={data} />}
      { flightsStaticPageType[pageType] && !isDeviceMobile && <CityDT data={data} />}
      { flightsStaticPageType[pageType] && isDeviceMobile && <CityPWA data={data} />}
      { destinationPickerDTPageType[pageType] && !isDeviceMobile && <CityCountryDT data={data} />}
    </>
  );
}

Body.propTypes = {
  // eslint-disable-next-line react/require-default-props, react/forbid-prop-types, react/no-unused-prop-types
  props: PropTypes.object,
};
